import { render } from "./NewTDA.vue?vue&type=template&id=c21ef86a&scoped=true"
import script from "./NewTDA.vue?vue&type=script&lang=js"
export * from "./NewTDA.vue?vue&type=script&lang=js"

import "./NewTDA.vue?vue&type=style&index=0&id=c21ef86a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21ef86a"]])

export default __exports__